import { TrailerType } from '@/types/TrailerType';
import { AxiosRequestConfig } from 'axios';
import http from './api-client';

const apiEndpoint = '/games';

/**
 * Fetches the list of game trailers from the API.
 * @param config - Configuration for the HTTP request
 * @returns Promise containing the game trailers list
 */
export const getTrailers = async (id: number | string, config?: AxiosRequestConfig) =>
    await http
        .get<TrailerType[]>(`${apiEndpoint}/${id}/movies`, { ...config })
        .then((res) => res.data);
